import { baseConocimientoFormModel } from './baseConocimientoFormModel';

const {
    formField: {
        name,
        description,
        embeddingProvider,
        embeddingModel,
        file
    }
} = baseConocimientoFormModel;

export const formInitialValues = {
    [name.name]: '',
    [description.name]: '',
    [embeddingProvider.name]: null,
    [embeddingModel.name]: null,
    [file.name]: null
};
